import React from 'react';
import { Link } from 'react-router-dom';
import { BadgePercent } from 'lucide-react';
import { INR } from '../lib/shop';
import { FREE_SHIP_MIN, SHIPPING_FEE, NO_FEES_LINE } from '../lib/catalog';

export const PriceDetails = ({ items, subtotal, offers = [], children }) => {
  const mrp = items.reduce((s, it) => s + (it.original_price && it.original_price > it.price ? it.original_price : it.price) * it.qty, 0);
  const offerOff = offers.reduce((s, o) => s + o.amount, 0);
  const net = subtotal - offerOff;
  const ship = net >= FREE_SHIP_MIN ? 0 : SHIPPING_FEE;
  const savings = mrp - net;
  const count = items.reduce((n, it) => n + it.qty, 0);
  return (
    <aside className="si-card h-fit md:sticky md:top-44" data-testid="price-details">
      <p className="px-5 py-3 border-b border-[var(--si-line)] text-sm font-bold uppercase tracking-wide text-[var(--si-grey)]">Price details</p>
      <div className="px-5 py-4 space-y-3 text-[15px]">
        <div className="flex justify-between"><span>Price ({count} item{count === 1 ? '' : 's'})</span><span>{INR(mrp)}</span></div>
        {mrp > subtotal && <div className="flex justify-between"><span>Sale discount</span><span className="si-off">− {INR(mrp - subtotal)}</span></div>}
        {offers.map((o) => (
          <div key={o.offer} className="flex justify-between" data-testid={`price-offer-${o.offer}`}><span>{o.label} ({o.free_items} free)</span><span className="si-off">− {INR(o.amount)}</span></div>
        ))}
        <div className="flex justify-between" data-testid="price-delivery"><span>Delivery charges</span>{ship ? <span>{INR(ship)}</span> : <span className="si-off">FREE</span>}</div>
        <div className="flex justify-between"><span>Platform / processing fee</span><span className="si-off">₹0</span></div>
        <div className="flex justify-between pt-3 border-t border-dashed border-[#C7CCD6] text-lg font-bold">
          <span>Total amount <span className="block text-xs font-normal text-[var(--si-grey)]">Inclusive of all taxes</span></span><span data-testid="price-total">{INR(net + ship)}</span>
        </div>
        {savings > 0 && <p className="si-off text-sm" data-testid="price-savings">You will save {INR(savings)} on this order</p>}
        {ship > 0 && <p className="text-sm text-[var(--si-grey)]">Add {INR(FREE_SHIP_MIN - net)} more for FREE delivery. <Link to="/shop" className="text-[var(--si-blue)] font-semibold">Shop more</Link></p>}
        <p className="flex items-start gap-2 text-xs font-semibold text-[var(--si-green)] bg-[#E8F5E9] rounded p-2"><BadgePercent className="w-4 h-4 shrink-0" />{NO_FEES_LINE}</p>
      </div>
      {children && <div className="px-5 pb-5">{children}</div>}
    </aside>
  );
};

export default PriceDetails;
